var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4 xl:gap-2 auto-cols-min"},_vm._l((_vm.getGraphData),function(graphDataSet){return _c('dynamic-report-query-graph-item',{key:graphDataSet.id,attrs:{"id":graphDataSet.id,"graph-config":graphDataSet.graphConfig,"name":graphDataSet.name}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }